import axios from "axios";
import store from "@/store";

const apiOrigin = (process.env.VUE_APP_API_URL || window.location.origin)
  .replace(/\/$/, "")
  .replace(/\/api(?:\/v1)?$/, "");

const normalizeApiUrl = (url) => {
  if (!url || typeof url !== "string") return url;
  if (/^(https?:)?\/\//.test(url) || url.startsWith("data:")) return url;

  const clean = url.trim().replace(/^\/+/, "");

  if (!clean) return url;
  if (clean === "api") return "/api/v1";
  if (clean === "api/v1") return "/api/v1";
  if (clean.startsWith("api/v1/")) return `/${clean}`;
  if (clean === "v1") return "/api/v1";
  if (clean.startsWith("v1/")) return `/api/${clean}`;
  if (clean.startsWith("api/")) return `/api/v1/${clean.slice(4)}`;

  return url;
};

const instance = axios.create({
  baseURL: apiOrigin,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  responseType: "json",
});

instance.interceptors.request.use(
  function (config) {
    config.url = normalizeApiUrl(config.url);

    const token =
      store.getters["authModule/getToken"] || localStorage.getItem("accessToken");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    } else {
      delete config.headers["Authorization"];
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("userData");

      await store.dispatch("authModule/setIsAuthenticated", {
        isAuthenticated: false,
        token: null,
      });

      await store.dispatch("authModule/clearPersistedState");
      await store.dispatch("userModule/removeUser");
      await store.dispatch("userModule/setPermissions", {
        permissions: null,
      });

      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
